import React from "react";
import { withTranslation } from "react-i18next";
import { getTimeFrameContent, isShowingWarningForToolbar } from "../../lib/common";
import { OverlayTrigger, Button, Tooltip } from "react-bootstrap";
import KnoaDropdown from "../Common/KnoaDropdown";
import KnoaDropdownNav from "../Common/KnoaDropdownNav";
import { getWarningMessages } from "../../lib/notifications/messageUtils";

const ToolbarItem = ({ children, className = "" }) => (
    <div className={`report-toolbar-item ${className}`}>{children}</div>
);

const DuelTimeframeContent = ({ reportFilters, projectID, t }) => {
    const showWarning = isShowingWarningForToolbar(reportFilters);
    return showWarning ? (
        <OverlayTrigger
            overlay={
                <Tooltip id="benchmarkwarningtooltip">
                    {getWarningMessages(t, "benchmarkSlider", null)}
                </Tooltip>
            }
            placement="top"
            delayShow={300}
            delayHide={150}
            trigger={["hover", "focus"]}
        >
            <div className="report-toolbar-Timeframe-warning-content">
                <div className="report-toolbar-Timeframe-warning-background">
                    <div className="report-toolbar-Timeframe-warning-container">
                        <div className="benchmarking-warning-left">
                            <i className="fa fa-warning benchmarking-warning-left-icon" />
                        </div>
                        <div className="benchmarking-warning-right">
        <span className="pressText report-toolbar-Timeframe-content-span">
          {t("report.filter:benchmarkPeriod")}
        </span>
                            <span className="pressText report-toolbar-Timeframe-content-row-span">
          {getTimeFrameContent(reportFilters, "benchmark", projectID, t)}
        </span>
                        </div>
                    </div>
                </div>
            </div>
        </OverlayTrigger>
    ) : (
        <div className="report-toolbar-Timeframe-content">
            <div>
                <span className="pressText report-toolbar-Timeframe-content-span">
                  {t("report.filter:benchmarkPeriod")}
                </span>
            </div>
            <div className="report-toolbar-Timeframe-content-row">
                <span className="pressText report-toolbar-Timeframe-content-row-span">
                  {getTimeFrameContent(reportFilters, "benchmark", projectID, t)}
                </span>
            </div>
        </div>
    );
};

const TimeframeContent = ({ reportFilters, projectID, t }) => (
    <div className="report-toolbar-Timeframe-content">
        <div>
          <span className="pressText report-toolbar-Timeframe-content-span-withcolor">
            {t("report.filter:basePeriod")}
          </span>
        </div>
        <div className="report-toolbar-Timeframe-content-row">
          <span className="pressText report-toolbar-Timeframe-content-row-span-withcolor">
            {getTimeFrameContent(reportFilters, "base", projectID, t)}
          </span>
        </div>
    </div>
);

const FilterContent = ({ showFiltersSection, handleShow, activeFilters, t }) => (
    <Button className={`dropdownContainer ${showFiltersSection ? "dropdownContainerHide" : "dropdownContainerShow"}`} onClick={handleShow}>
        <i className="fa fa-filter knoaButtonIcon" />
        <div className="d-inline-flex align-items-center gap-1">
            <span className="pressText report-toolbar-FilterContent-div-span">
                {t("report.filter:filters")}
            </span>
            <span className="pressText report-toolbar-Timeframe-content-row-span">
                ({activeFilters} {t("report.filter:active")})
            </span>
        </div>
    </Button>
);

const DrillContent = ({
                          showBack,
                          dataRangeType,
                          currentWorkbook,
                          backClick,
                          options,
                          setDrillEnabled,
                          instanceWorkbookId,
                          isDataReport,
                          t,
                      }) => {
    const name = currentWorkbook?.workbookName || "";

    const showDropdown =
        (dataRangeType === "instance" && !name.endsWith("workflow")) ||
        ((["current", "historical"].includes(dataRangeType)) &&
            (name.endsWith("daily") || name.endsWith("monthly") || name.endsWith("flows")));

    return (
        <>
            {showDropdown && !isDataReport && (
                <KnoaDropdown
                    currentWorkbook={currentWorkbook}
                    options={options}
                    setDrillEnabled={setDrillEnabled}
                    instanceWorkbookId={instanceWorkbookId}
                    dataRangeType={dataRangeType}
                    icon="fa fa-share-square-o"
                />
            )}
            {showBack && (
                <Button className="toolbarBtn" onClick={backClick}>
                    <i className="fa fa-mail-reply knoaButtonIcon" />
                    <span className="pressText">{t("common:back")}</span>
                </Button>
            )}
        </>
    );
};

const MoreContent = ({ moreMenuOptions, setDropdownToggleRef }) => (
    <KnoaDropdownNav options={moreMenuOptions} setDropdownToggleRef={setDropdownToggleRef} />
);

const ReportToolbar = ({
                           currentWorkbook,
                           timeframe,
                           filter,
                           drill,
                           more,
                           handleShow,
                           showFiltersSection,
                           t,
                       }) => {
    const name = currentWorkbook?.workbookName || "";
    const showFilter =
        filter &&
        ["daily", "monthly", "workflows", "instances"].some((suffix) =>
            name.endsWith(suffix)
        );
    let showBack;
    if(drill?.instanceEnabled) {
        showBack =
            drill.dataRangeType === "instance" ||
            drill.isDataReport ||
            (["current", "historical"].includes(drill.dataRangeType) && name.endsWith("flow"));
    }

    return (
        <div className="report-toolbar-row knoa-region" role="toolbar" tabIndex="-1">
            {timeframe?.reportFilters?.dualPeriod && (
                <ToolbarItem>
                    <DuelTimeframeContent
                        reportFilters={timeframe.reportFilters}
                        projectID={timeframe.projectID}
                        t={t}
                    />
                </ToolbarItem>
            )}
            {timeframe && (
                <ToolbarItem>
                    <TimeframeContent
                        reportFilters={timeframe.reportFilters}
                        projectID={timeframe.projectID}
                        t={t}
                    />
                </ToolbarItem>
            )}
            {showFilter && (
                <ToolbarItem>
                    <FilterContent
                        showFiltersSection={showFiltersSection}
                        handleShow={handleShow}
                        activeFilters={filter.numOfActiveFilters}
                        t={t}
                    />
                </ToolbarItem>
            )}
            {drill?.instanceEnabled && (
                <ToolbarItem className={showBack ? "gap-14px" : ""}>
                    <DrillContent
                        showBack={showBack}
                        currentWorkbook={currentWorkbook}
                        dataRangeType={drill.dataRangeType}
                        backClick={drill.backClick}
                        options={drill.options}
                        setDrillEnabled={drill.setDrillEnabled}
                        instanceWorkbookId={drill.instanceWorkbookId}
                        isDataReport={drill.isDataReport}
                        t={t}
                    />
                </ToolbarItem>
            )}
            <ToolbarItem>
                <MoreContent moreMenuOptions={more.moreMenuOptions} setDropdownToggleRef={more.setDropdownToggleRef} />
            </ToolbarItem>
        </div>
    );
};

export default withTranslation()(ReportToolbar);